import { useModalStore } from '~/stores/useModalStore';
import { passStoreThroughComposableFactory } from '~/utils/passStoreThroughComposableFactory';

/**
 * Composable function to open and close modal windows
 */
export const useModal = () => passStoreThroughComposableFactory(useModalStore());
